import { Component, Input, OnInit, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { UUID } from 'angular2-uuid';
import { FormBuilderUDFService } from 'src/app/services/form-builder-udf-service';
import { BaseApi } from 'src/backend/api/base-api';
@Component({
  selector: 'app-list-property',
  templateUrl: './list-property.component.html',
  styleUrls: ['./list-property.component.scss']
})


export class ListPropertyComponent implements OnInit {
  @ViewChild('AgGridRowDataPoup') private AgGridRowDataPoup!: TemplateRef<any>;
  datasource: string;
  private _attributes: any;
  public varcharAttributes: Array<any> = [];
  @Input() component: any;
  jsonInput: string = '';
  errorMessage: string | null = null;
  cellEditorParamsValues: any;
  public frameworkComponents: any;
  buttonEdit: boolean;
  buttonDelete: boolean;
  apiList: any;
  apiEndpoint
  filteredAPIS: any;
  pageList!: any[];
  filteredPages: any[] = [];
  plantSession: any;
  @Input() set attributes(value: any) {
    this._attributes = value;

    if (this._attributes) {
      this.varcharAttributes = _.sortBy(
        this._attributes.filter((att: any) => {
          return att.type === 'varchar';
        }),
        ['name']
      );
    }
  }

  get attributes(): any {
    return this._attributes;
  }
  @Output() onBindVariableChange: EventEmitter<any> = new EventEmitter();
  constructor(private dialog: MatDialog, private toaster: ToastrService,private formService: FormBuilderUDFService,private baseApi : BaseApi) {
  }

  ngOnInit(): void {
    //this.component.element.columnDefs = [];  i have commented because onload page list being disapear
    //this.component.element.rowData = [];
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.getPages();
    this.getAPIList();
  }

  onChangeDatasourcetype(selected: any) {
    this.datasource = selected.value;
    if(this.datasource === 'url') {
      this.getAPIList();
    }
  }

  onChangeAPI(apiId: any) {   
    const APIDetails = this.apiList.find((api: any) => api.id === apiId);
    if (APIDetails) {
      this.component.element.requestType = APIDetails ? APIDetails.APIRequestType : '';
    this.component.element.datasourceUrl = APIDetails ? APIDetails.APIURL : '';
    this.component.element.datasourceParamaters = APIDetails ? APIDetails.APIPayloadParameter : '';
    this.component.element.resultsetName = APIDetails ? APIDetails.APIResponseResultSetName : '';
    }
   
  }

  onChangeListType(selected: any) {
    this.component.element.listtype = selected.value;
    if (this.component.element.listtype === 'reportlist') {
      this.getPages();
    }
  }

  addColumns() {
    this.component.element.columnDefs.push({
      id: UUID.UUID(), // Add a unique identifier
      headerName: '',
      field: '',
      editable: false,
      sortable: false,
      resizable: false,
      cellEditor: '',
      cellEditorSelect: false,
      cellEditorCheckbox: false,
      cellEditorParamsValues: '',
    });
  }

  addColDefs() {
    this.component.element.columnDefs = this.component.element.columnDefs.map((v: any) => {
      if (v) {
        if (v.cellEditorCheckbox && v.cellEditorSelect) {
          this.toaster.info('info', 'Please select one option');
          return v;
        }

        // For checkbox columns
        if (v.cellEditorCheckbox) {
          return {
            ...v,
            cellRenderer: 'agCheckboxCellRenderer',
            cellEditor: 'agCheckboxCellEditor',
            editable: true
          };
        }

        // For dropdown columns
        if (v.cellEditorSelect) {
          return {
            ...v,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: { values: this.cleanArray(v.cellEditorParamsValues || '') },
            editable: true
          };
        }

        // For other columns with edit/delete buttons
        const cellRenderer = this.buttonEdit ? 'buttonEditRenderer' : this.buttonDelete ? 'buttonDeleteRenderer' : undefined;

        return {
          ...v,
          cellRenderer
        };
      }
      return v;
    });

    this.refreshGrid();

  }

  cleanArray(str: string): string[] {
    return str.split(',').map(item => item.trim());
  }

  removeColumns(index: number) {
    this.component.element.columnDefs = this.component.element.columnDefs.filter((_: any, idx: number) => idx !== index);
  }

  openAGGridDataModel() {
    const dialogRef = this.dialog.open(this.AgGridRowDataPoup, {
      minWidth: '60%',
      minHeight: '50%',
    });

    dialogRef.afterOpened().subscribe(() => {
      let jsonData = [];
      const rowDataLength = this.component.element.rowData ? this.component.element.rowData.length : 10;
      for (let i = 0; i < rowDataLength; i++) {
        let emptyObject = {};
        for (let column of this.component.element.columnDefs) {
          emptyObject[column.field] = this.component.element.rowData && this.component.element.rowData[i] ? this.component.element.rowData[i][column.field] : "";
        }
        jsonData.push(emptyObject);
      }
      this.jsonInput = JSON.stringify(jsonData, null, 2);
    });

    dialogRef.afterClosed().subscribe(() => {
      // handle after closed logic if needed
    });
  }

  addData() {
    try {
      const cleanedJsonString = `[${this.jsonInput.trim()}]`;
      const jsonData = JSON.parse(cleanedJsonString);
      this.processJsonData(jsonData);
      this.toaster.success("Data added successfully");
      this.dialog.closeAll();
    } catch (error) {
      this.toaster.error("Invalid JSON format");
    }
  }

  processJsonData(data: any[]) {
    console.log("Data received:", data);
    console.log("Column Definitions:", this.component.element.columnDefs);

    const matchedData = this.parseAndMatchData(data);

    if (matchedData.length > 0) {
      this.component.element.rowData = matchedData[0];
      this.errorMessage = null;
    } else {
      this.errorMessage = "JSON data does not match the column definitions.";
      this.toaster.error(this.errorMessage);
      this.component.element.rowData = [];
    }
  }

  parseAndMatchData(data: any[]) {
    return data.filter((item, index) => this.component.element.columnDefs.every((colDef: any) => colDef.field in item[index]));
  }



  refreshGrid() {
    // Assuming there's a method to refresh or re-render your AG Grid
    this.component.element.gridOptions.api.setColumnDefs(this.component.element.columnDefs);
  }

  handleOnBindVariableChange($event: any) {
    this.onBindVariableChange.emit({
      value: $event,
      id: this.component.id
    });
  }

  getAPIList() {
    this.formService.getAPIList().subscribe({
      next: (data: any) => {
      if (data) {
        this.apiList = data.Table;
        this.filteredAPIS = this.apiList.slice();
      }
      },
      error: (error: any) => {
      this.toaster.error('Error fetching API list');
      }
    });
  }

  getPages(): void {
    this.formService.getFormsTable().subscribe((data: any) => {
      this.pageList = data.Table;
      this.filteredPages = this.pageList.slice();
    }, (error: any) => {
      this.toaster.error('error', error.message);
    });
  };

  generateRows(): void {
    const rowCount = this.component.element.initialRowCount || 0;
    if (rowCount <= 0) {
      this.toaster.info('Please enter a valid number of rows');
      return;
    }

    const cols = this.component.element.columnDefs || [];
    if (cols.length === 0) {
      this.toaster.warning('Please add columns first');
      return;
    }

    const rows: any[] = [];
    for (let i = 0; i < rowCount; i++) {
      const row: any = {};
      for (const column of cols) {
        if (column.field && column.field !== '__delete' && column.field !== '__edit') {
          row[column.field] = '';
        }
      }
      rows.push(row);
    }

    this.component.element.rowData = rows;
    this.toaster.success(`${rowCount} rows generated successfully`);
  }

  onLabelChange(label: string) {
    // Update field name: convert to lowercase, replace spaces/special chars with underscores
    this.component.element.field_name = label
      ? label.toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')  // Replace non-alphanumeric chars with underscore
          .replace(/^_+|_+$/g, '')       // Remove leading/trailing underscores
          .replace(/_+/g, '_')           // Replace multiple underscores with single
          .substring(0, 100)             // Limit to 100 characters
      : '';
  }

}
